/**
 * Selettore di commessa con ricerca.
 *
 * L'elenco a tendina semplice non basta con un centinaio di commesse: qui si
 * cerca per CLIENTE, numero o titolo, e i risultati mostrano il cliente in
 * evidenza — è il modo in cui si ragiona quando si registra un'offerta.
 */
import { useEffect, useMemo, useRef, useState } from 'react';

export default function SelettoreCommessa({ commesse, value, onChange, placeholder }) {
  const [aperto, setAperto] = useState(false);
  const [q, setQ] = useState('');
  const box = useRef(null);

  const scelta = commesse.find(c => String(c.id) === String(value));

  // Chiude la tendina cliccando fuori: senza questo resterebbe aperta
  // coprendo i campi sottostanti.
  useEffect(() => {
    const fuori = (e) => { if (box.current && !box.current.contains(e.target)) setAperto(false); };
    document.addEventListener('mousedown', fuori);
    return () => document.removeEventListener('mousedown', fuori);
  }, []);

  const risultati = useMemo(() => {
    const t = q.trim().toLowerCase();
    const base = commesse.filter(c => c.stato !== 'annullata');
    if (!t) return base.slice(0, 50);
    return base.filter(c =>
      `${c.cliente_nome || ''} ${c.numero} ${c.titolo}`.toLowerCase().includes(t)
    ).slice(0, 50);
  }, [commesse, q]);

  const scegli = (c) => { onChange(c ? String(c.id) : ''); setAperto(false); setQ(''); };

  return (
    <div className="relative" ref={box}>
      <button type="button" onClick={() => setAperto(a => !a)}
              className="input text-left flex items-center justify-between gap-2">
        <span className={scelta ? 'text-gray-900 truncate' : 'text-gray-400'}>
          {scelta
            ? <><span className="font-mono text-xs text-gray-500">{scelta.numero}</span>
                {' — '}{scelta.titolo}
                {scelta.cliente_nome && <span className="text-gray-500"> ({scelta.cliente_nome})</span>}</>
            : (placeholder || '— Nessuna commessa —')}
        </span>
        <span className="text-gray-400 shrink-0">▾</span>
      </button>

      {aperto && (
        <div className="absolute z-20 mt-1 w-full bg-white border rounded-lg shadow-lg">
          <div className="p-2 border-b">
            <input autoFocus className="input py-1 text-sm"
                   placeholder="Cerca per cliente, numero o titolo…"
                   value={q} onChange={e => setQ(e.target.value)} />
          </div>
          <div className="max-h-64 overflow-y-auto">
            <button type="button" onClick={() => scegli(null)}
                    className="w-full text-left px-3 py-2 text-sm text-gray-500 hover:bg-gray-50 border-b">
              — Nessuna commessa —
            </button>
            {risultati.length === 0 && (
              <p className="px-3 py-4 text-sm text-gray-400 text-center">Nessuna commessa trovata</p>
            )}
            {risultati.map(c => (
              <button key={c.id} type="button" onClick={() => scegli(c)}
                      className={`w-full text-left px-3 py-2 hover:bg-gray-50 border-b last:border-0
                                  ${String(c.id) === String(value) ? 'bg-brand-50' : ''}`}>
                <div className="flex items-baseline gap-2">
                  <span className="font-medium text-sm text-gray-800 truncate flex-1">
                    {c.cliente_nome || '— senza cliente —'}
                  </span>
                  <span className="font-mono text-xs text-gray-500 shrink-0">{c.numero}</span>
                </div>
                <div className="text-xs text-gray-500 truncate">{c.titolo}</div>
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
